module.exports = __webpack_public_path__ + "static/media/auaNormal.728aac92.svg";